<template>
  <div class="query-home-wrap">
    <my-header
        :current-title="['发票业务', '发票查询统计', '全量发票查询']"
        main-title="全量发票查询"
        class="query-header"
        @back="emit('switchPage', {key: 'home'})"
    />

    <div class="content-box">
      <div class="main-box">
        <el-tabs
            style="margin-top: -15px;"
            :modelValue="activeTab">
          <el-tab-pane label="发票查询" name="ticketQuery">
            <el-form :model="queryParams"
                     size="default"
                     class="my-form"
                     ref="formRef" :rules="rules" :inline="true" label-width="140px">
              <el-radio-group
                  class="my-radio-btn"
                  @change="queryData"
                  v-model="queryParams.timeType">
                <el-radio
                    style="margin-right: 0;"
                    value="1" border>近24小时
                </el-radio>
                <el-radio
                    value="2" border>全量
                </el-radio>
              </el-radio-group>

              <div class="form-item-wrap">
                <el-form-item label="查询类型"
                              prop="queryType">
                  <el-select
                      v-model="queryParams.queryType"
                      style="width: 201px"
                      placeholder="请选择">
                    <el-option label="开具发票" value="开具发票"/>
                    <el-option label="取得发票" value="取得发票"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票来源"
                              prop="ticSource">
                  <el-select
                      v-model="queryParams.ticSource"
                      style="width: 201px"
                      placeholder="请选择">
                    <el-option label="全部" value="全部"/>
                    <el-option label="增值税发票管理系统" value="增值税发票管理系统"/>
                    <el-option label="电子发票服务平台" value="电子发票服务平台"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="票种" prop="categoryCode">
                  <el-select
                      multiple
                      collapse-tags
                      clearable
                      v-model="queryParams.categoryCode"
                      style="width: 201px"
                      placeholder="请选择">
                    <template #header>
                      <el-checkbox
                          v-model="checkCategoryCodeAll"
                          :indeterminate="categoryCodeIndeterminate"
                          @change="handleCategoryCodeCheckAll"
                      >
                        全选
                      </el-checkbox>
                    </template>
                    <el-option
                        v-for="(item, idx) in categoryTypeList"
                        :key="idx"
                        :label="item.label" :value="item.value"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票状态" prop="invoiceStatus">
                  <el-select
                      multiple
                      collapse-tags
                      v-model="queryParams.invoiceStatus"
                      style="width: 201px"
                      placeholder="请选择">
                    <template #header>
                      <el-checkbox
                          v-model="checkInvoiceStatusAll"
                          :indeterminate="invoiceStatusIndeterminate"
                          @change="handleInvoiceStatusCheckAll"
                      >
                        全选
                      </el-checkbox>
                    </template>
                    <el-option label="正常" value="1"/>
                    <el-option label="已作废" value="2"/>
                    <el-option label="已红冲-全额" value="3"/>
                    <el-option label="已红冲-部分" value="4"/>
                  </el-select>
                </el-form-item>

                <el-form-item label="是否正数发票"
                              prop="positiveTic">
                  <el-select
                      v-model="queryParams.positiveTic"
                      style="width: 201px"
                      placeholder="请选择">
                    <el-option label="全选" value="全选"/>
                    <el-option label="是" value="1"/>
                    <el-option label="否" value="0"/>
                  </el-select>
                </el-form-item>

                <el-form-item
                    label="数电票号码"
                    prop="code">
                  <el-input
                      v-model.trim="queryParams.code"
                      style="width: 201px"
                      clearable
                      placeholder="请输入"/>
                </el-form-item>

                <el-form-item
                    label="发票代码"
                    prop="invoiceCode">
                  <el-input
                      v-model.trim="queryParams.invoiceCode"
                      style="width: 201px"
                      clearable
                      placeholder="请输入"/>
                </el-form-item>

                <el-form-item
                    label="发票号码"
                    prop="invoiceNumber">
                  <el-input
                      v-model.trim="queryParams.invoiceNumber"
                      style="width: 201px"
                      clearable
                      placeholder="请输入"/>
                </el-form-item>

                <el-form-item
                    label="对方纳税人识别号"
                    prop="purchaseBuyCode">
                  <el-input
                      v-model.trim="queryParams.purchaseBuyCode"
                      style="width: 201px"
                      clearable
                      placeholder="请输入"/>
                </el-form-item>

                <el-form-item
                    label="对方纳税人名称"
                    prop="purchaseBuyName">
                  <el-input
                      v-model.trim="queryParams.purchaseBuyName"
                      style="width: 201px"
                      clearable
                      placeholder="请输入"/>
                </el-form-item>

                <el-form-item label="发票金额（起）">
                  <el-input-number
                      v-model.trim="queryParams.minAmount"
                      class="query-num"
                      :controls="false" :precision="2"
                      :step="0.01"
                      style="width: 201px"
                  />

                </el-form-item>

                <el-form-item label="发票金额（止）">
                  <el-input-number
                      v-model.trim="queryParams.maxAmount"
                      class="query-num"
                      style="width: 201px"
                      :controls="false" :precision="2" :step="0.01"
                  />

                </el-form-item>

                <el-form-item
                    v-if="queryParams.timeType == '2'"
                    label="开票日期（起）" prop="startTime">
                  <el-date-picker
                      v-model="queryParams.startTime"
                      type="date"
                      :disabled-date="disableMakeStart"
                      style="width: 201px"
                      value-format="YYYY-MM-DD"
                      placeholder="请选择"
                  />
                </el-form-item>

                <el-form-item
                    v-if="queryParams.timeType == '2'"
                    label="开票日期（止）" prop="endTime">
                  <el-date-picker
                      v-model="queryParams.endTime"
                      type="date"
                      :disabled-date="disableMakeEnd"
                      style="width: 201px"
                      value-format="YYYY-MM-DD"
                      placeholder="请选择"
                  />
                </el-form-item>

                <el-form-item style="padding-left: 75px;">
                  <el-button type="info" @click="reset">重置</el-button>
                  <el-button type="primary" @click="queryData">查询</el-button>
                  <el-button
                      text
                      type="primary"
                      icon="ArrowUp">收起
                  </el-button>
                </el-form-item>
              </div>
            </el-form>

            <div class="opera-row">
              <el-button>自定义列</el-button>
            </div>

            <el-table
                ref="tableRef"
                :data="showTableList"
                style="margin-top: 10px;"
                border
            >
              <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

              <el-table-column label="票种" align="left" prop="categoryCode" min-width="200">
                <template #default="{row}">
                  <span>{{ categoryTypeList.find(f => f.value == row.categoryCode)?.label }}</span>
                </template>
              </el-table-column>

              <el-table-column label="发票状态" align="center" prop="invoiceStatus" min-width="100">
                <template #default="{row}">
                  <el-tag v-if="row.invoiceStatus.indexOf('正常发票') > -1" type="success">正常</el-tag>
                </template>
              </el-table-column>

              <el-table-column label="数电票号码" align="center" prop="code" min-width="200"/>

              <el-table-column label="发票代码" align="center" prop="invoiceCode" min-width="120">
                <template #default>
                  --
                </template>
              </el-table-column>

              <el-table-column label="发票号码" align="center" prop="invoiceNumber" min-width="120">
                <template #default>
                  --
                </template>
              </el-table-column>

              <el-table-column label="发票风险等级" align="center" prop="riskLevel" min-width="120">
                <template #default>
                  <el-tag type="success">正常</el-tag>
                </template>
              </el-table-column>

              <el-table-column label="购/销方名称" align="left" prop="purchaseBuyName" min-width="240"/>

              <el-table-column label="购/销方识别号" align="center" prop="purchaseBuyCode" min-width="180"/>

              <el-table-column label="金额" align="center" prop="amount" min-width="120"/>

              <el-table-column label="税额" align="center" prop="taxAmount" min-width="120"/>

              <el-table-column label="价税合计" align="center" prop="totalAddedTaxAmount" min-width="120"/>

              <el-table-column label="特定业务类型" align="center" prop="specialType" min-width="120"/>

              <el-table-column label="开票日期" align="center" prop="createTime" min-width="190"/>

              <el-table-column label="查询类型" align="center" prop="queryType" min-width="120"/>

              <el-table-column label="发票来源" align="center" prop="ticSource" min-width="150"/>

              <el-table-column label="开票人" align="center" prop="maker" min-width="100"/>

              <el-table-column
                  fixed="right"
                  label="操作" align="center"
                  min-width="150">
                <template #default="{row}">
                  <el-button
                      size="small"
                      type="primary" link
                  >详情
                  </el-button>

                  <el-button
                      size="small"
                      type="primary" link
                      @click="goPreview(row)"
                  >预览
                  </el-button>

                  <el-button
                      size="small"
                      type="primary" link
                  >交付
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="paginate-wrap">
              <span class="total">共 {{ pageTotal }} 条</span>
              <pagination
                  :total="pageTotal"
                  v-model:page="queryParams.pageNum"
                  v-model:limit="queryParams.pageSize"
                  layout="sizes,prev, pager, next, jumper"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="海关缴款书查询" name="customsQuery">
            <el-empty description="暂无数据"/>
          </el-tab-pane>
        </el-tabs>
      </div>

      <footer class="footer">
        <img src="https://static.rhkj.com/renhe_fe/other/333.png">
      </footer>
    </div>

    <invoce-dialog
        v-model="previewVis"
        :row="currentRow"
    />
  </div>
</template>

<script setup>
import myHeader from "../cmp/myHeader.vue";
import dayjs from "dayjs";
import {useAllInvoice, categoryTypeList} from "./allInvoiceSummary.js";
import InvoceDialog from "@/views/digitalInvoice/cmp/invoceDialog.vue";

const emit = defineEmits(['switchPage'])
const formRef = ref()

const queryParams = reactive({
  timeType: '2',
  queryType: '开具发票',
  ticSource: '全部',
  invoiceStatus: ['1', '2', '3', '4'],
  pageNum: 1,
  pageSize: 50,
  startTime: dayjs().startOf('month').format('YYYY-MM-DD'),
  endTime: dayjs().endOf('month').format('YYYY-MM-DD'),
})
const rules = reactive({
  queryType: {required: true, message: '必选', trigger: ['blur', 'change']},
})
const activeTab = ref('ticketQuery')
const showTableList = ref([])
const pageTotal = ref(0)

const {initialData} = useAllInvoice()

function queryData() {
  showTableList.value = initialData.value.filter(f => { // 前端筛选实现
    let pass = true
    if (queryParams.queryType) {
      pass = pass && (f.queryType == queryParams.queryType)
    }
    if (queryParams.ticSource && queryParams.ticSource != '全部') {
      pass = pass && (f.ticSource == queryParams.ticSource)
    }
    if (queryParams.categoryCode?.length) {
      pass = pass && (queryParams.categoryCode.includes(f.categoryCode))
    }
    if (queryParams.invoiceStatus?.length) {
      pass = pass && (queryParams.invoiceStatus.includes('1')) // 发票状态只要有正常的就能查到全部
    }
    if (queryParams.positiveTic && queryParams.positiveTic != '全选') {
      pass = pass && ((queryParams.positiveTic == '1' && parseFloat(f.amount) > 0) || (queryParams.positiveTic == '0' && parseFloat(f.amount) < 0))
    }
    if (queryParams.purchaseBuyCode) {
      pass = pass && (f.purchaseBuyCode.indexOf(queryParams.purchaseBuyCode) > -1)
    }
    if (queryParams.code) {
      pass = pass && (f.code.indexOf(queryParams.code) > -1)
    }
    if (queryParams.purchaseBuyName) {
      pass = pass && (f.purchaseBuyName.indexOf(queryParams.purchaseBuyName) > -1)
    }
    if (queryParams.minAmount != null) {
      pass = pass && (parseFloat(f.amount) >= queryParams.minAmount)
    }
    if (queryParams.maxAmount != null) {
      pass = pass && (parseFloat(f.amount) <= queryParams.maxAmount)
    }
    if (queryParams.timeType == '1') { // 近24小时
      const c = dayjs(f.createTime, 'YYYY-MM-DD HH:mm:ss')
      const s = dayjs().subtract(24, 'hour')
      const e = dayjs()
      pass = pass && ((s.isBefore(c) || s.isSame(c)) && (e.isAfter(c) || e.isSame(c)))
    }
    if (queryParams.timeType == '2' && (queryParams.startTime || queryParams.endTime)) {
      const c = dayjs(f.createTime, 'YYYY-MM-DD HH:mm:ss')
      const s = dayjs(queryParams.startTime || '1970-01-01', 'YYYY-MM-DD').startOf('day')
      const e = dayjs(queryParams.endTime || '2099-12-31', 'YYYY-MM-DD').endOf('day')
      pass = pass && ((s.isBefore(c) || s.isSame(c)) && (e.isAfter(c) || e.isSame(c)))
    }
    return pass
  })
  pageTotal.value = showTableList.value.length
}

function reset() {
  formRef.value && formRef.value.resetFields();
}

const previewVis = ref(false)
const currentRow = ref({})

function goPreview(row) {
  currentRow.value = row.originTicData
  previewVis.value = true
}

const checkCategoryCodeAll = ref(false)
const categoryCodeIndeterminate = ref(false)

watch(() => queryParams.categoryCode, (val) => {
  if (!val || val.length === 0) {
    checkCategoryCodeAll.value = false
    categoryCodeIndeterminate.value = false
  } else if (val.length === 19) {
    checkCategoryCodeAll.value = true
    categoryCodeIndeterminate.value = false
  } else {
    categoryCodeIndeterminate.value = true
  }
})

const handleCategoryCodeCheckAll = (val) => {
  categoryCodeIndeterminate.value = false
  if (val) {
    queryParams.categoryCode = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19']
  } else {
    queryParams.categoryCode = []
  }
}

const checkInvoiceStatusAll = ref(true)
const invoiceStatusIndeterminate = ref(false)

watch(() => queryParams.invoiceStatus, (val) => {
  if (!val || val.length === 0) {
    checkInvoiceStatusAll.value = false
    invoiceStatusIndeterminate.value = false
  } else if (val.length === 4) {
    checkInvoiceStatusAll.value = true
    invoiceStatusIndeterminate.value = false
  } else {
    invoiceStatusIndeterminate.value = true
  }
})

const handleInvoiceStatusCheckAll = (val) => {
  invoiceStatusIndeterminate.value = false
  if (val) {
    queryParams.invoiceStatus = ['1', '2', '3', '4']
  } else {
    queryParams.invoiceStatus = []
  }
}

function disableMakeStart(date) {
  // 开始时间不能大于结束时间
  if (queryParams.endTime && dayjs(date).isAfter(dayjs(queryParams.endTime, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

function disableMakeEnd(date) {
  // 开始时间不能大于结束时间
  if (queryParams.startTime && dayjs(date).isBefore(dayjs(queryParams.startTime, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}
</script>


<style scoped lang="scss">
.query-home-wrap {
  height: 100vh;
  overflow-x: hidden;

  .content-box {
    padding-top: 24px;
    background-color: rgb(238, 238, 238);
    height: calc(100vh - 140px);
    overflow-y: auto;

    .main-box {
      background-color: #FFFFFF;
      padding: 24px 12px 24px 12px;
      margin: 0 24px 0 24px;

      .my-form {
        padding: 5px 0 0 5px;

        :deep(.my-radio-btn) {
          .el-radio__input {
            display: none;
          }
        }

        .form-item-wrap {
          margin-top: 20px;

          :deep(.query-num) {
            .el-input__inner {
              text-align: left;
            }
          }
        }
      }

      .opera-row {
        display: flex;
        flex-direction: row-reverse;
        padding: 0 20px;
      }

      .paginate-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;

        .total {
          color: #666666;
          font-size: 14px;
        }
      }
    }

    .footer {
      background-color: rgb(238, 238, 238);
      display: flex;
      justify-content: center;
      padding: 30px 0;
      opacity: 0.9;
    }
  }
}
</style>
